export type ChartType = "bar" | "line" | "area" | "pie"

export type ChartSpec = {
  chartType: ChartType
  title?: string
  xKey: string
  yKeys: string[]
  unit?: string
  data: Record<string, string | number>[]
}

export type ParseChartResult =
  | { ok: true; spec: ChartSpec }
  | { ok: false; error: "invalid_json" | "invalid_spec"; detail?: string }

const CHART_TYPES: ChartType[] = ["bar", "line", "area", "pie"]

export function parseChartSpec(raw: string): ParseChartResult {
  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    return { ok: false, error: "invalid_json" }
  }
  if (typeof parsed !== "object" || parsed === null) {
    return { ok: false, error: "invalid_spec", detail: "not an object" }
  }
  const candidate = parsed as Record<string, unknown>
  if (!CHART_TYPES.includes(candidate.chartType as ChartType)) {
    return { ok: false, error: "invalid_spec", detail: "unknown chartType" }
  }
  if (typeof candidate.xKey !== "string" || !candidate.xKey) {
    return { ok: false, error: "invalid_spec", detail: "missing xKey" }
  }
  if (!Array.isArray(candidate.yKeys) || candidate.yKeys.length === 0) {
    return { ok: false, error: "invalid_spec", detail: "missing yKeys" }
  }
  if (!Array.isArray(candidate.data) || candidate.data.length === 0) {
    return { ok: false, error: "invalid_spec", detail: "missing data" }
  }
  for (const row of candidate.data) {
    if (row === null || typeof row !== "object" || Array.isArray(row)) {
      return { ok: false, error: "invalid_spec", detail: "invalid data row" }
    }
  }
  return {
    ok: true,
    spec: {
      chartType: candidate.chartType as ChartType,
      title: typeof candidate.title === "string" ? candidate.title : undefined,
      xKey: candidate.xKey,
      yKeys: candidate.yKeys.map(String),
      unit: typeof candidate.unit === "string" ? candidate.unit : undefined,
      data: candidate.data as Record<string, string | number>[],
    },
  }
}
